module.exports = __webpack_public_path__ + "static/media/inline-sparkle.5de4e402.svg";